import { POST } from "./";
export const projectEmitCertificationConfirm = {
  save: data => POST(`/api/projectEmitCertificationConfirm/`, data)
};
